import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setSerial
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onCloseModal
 * @method onSerialExpire
 * event
 * @event sendCloseModal
 * @event sendSerialExpire
 */
export function CopySuccessModalController() {
    this.serialModel = null;
    this.isBottom = false;
    this.busModal = mitt();

    this.callbackClose = null;
    this.callbackSerialExpire = null;

    //#region setter
    this.setIsBottom = function(isBottom){
        this.isBottom = isBottom;
        return this;
    }
    this.clearModal = function () {
        this.serialModel = null;
        this.isBottom = false;
        this.callbackClose = null;
        this.callbackSerialExpire = null;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            serialModel: this.serialModel,
            isBottom: this.isBottom,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onCloseModal = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackClose = callback;
        }
    };
    this.sendCloseModal = function(data) {
        if (Util.isFunction(this.callbackClose)) {
            this.callbackClose(data);
        }
    };
    //#endregion event
}
